<div *ngIf="busy">Two racquets started dating... Unfortunately, one was stringing the other along.<br />Loading....</div>
<div *ngIf="queryFailed">No tournament found. You may need to click '<a id="mylevels" class="" [routerLink]="['/ladderlevel']">My Ladders/Levels</a>' and switch to a different ladder?</div>

<div *ngIf="!busy && !queryFailed" class="tournament-bracket">

  <button *ngIf="showRecord" [routerLink]="['/record-tournament']">Record Match</button>
  &nbsp;
  <a [routerLink]="['/alltournament']">See All Brackets</a>

  <table style="background: #fff; width: 100%;">
    <tr>
      <td class="round8 player">{{tournamentBracket.round8|player:0}}</td>
      <td class="round4"></td>
      <td class="round2"></td>
      <td class="round1"></td>
    </tr>
    <tr>
      <td class="round8"></td>
      <td class="round4 player left-bordered">{{tournamentBracket.round4|player:0}}</td>
      <td class="round2"></td>
      <td class="round1"></td>
    </tr>
    <tr>
      <td class="round8 player">{{tournamentBracket.round8|player:1}}</td>
      <td class="round4 score left-bordered">{{tournamentBracket.round4|score:0}}</td>
      <td class="round2 left-bordered"></td>
      <td class="round1"></td>
    </tr>
    <tr>
      <td class="round8 player">{{tournamentBracket.round8|player:2}}</td>
      <td class="round4"></td>
      <td class="round2 player left-bordered">{{tournamentBracket.round2|player:0}}</td>
      <td class="round1"></td>
    </tr>
    <tr>
      <td class="round8"></td>
      <td class="round4 player left-bordered">{{tournamentBracket.round4|player:1}}</td>
      <td class="round2 score left-bordered">{{tournamentBracket.round2|score:00}}</td>
      <td class="round1 left-bordered"></td>
    </tr>
    <tr>
      <td class="round8 player">{{tournamentBracket.round8|player:3}}</td>
      <td class="round4 score left-bordered">{{tournamentBracket.round4|score:1}}</td>
      <td class="round2"></td>
      <td class="round1 left-bordered"></td>
    </tr>

    <tr class="center-row">
      <td class="round8"></td>
      <td class="round4"></td>
      <td class="round2"></td>
      <td class="round1 player left-bordered">
        <fa-icon [icon]="faTrophy"></fa-icon>
        &nbsp;
        <b>{{tournamentBracket.round1|player:0}}</b>
      </td>
    </tr>

    <tr>
      <td class="round8 player">{{tournamentBracket.round8|player:4}}</td>
      <td class="round4"></td>
      <td class="round2"></td>
      <td class="round1 score left-bordered">{{tournamentBracket.round1|score:0}}</td>
    </tr>
    <tr>
      <td class="round8"></td>
      <td class="round4 player left-bordered">{{tournamentBracket.round4|player:2}}</td>
      <td class="round2"></td>
      <td class="round1 left-bordered"></td>
    </tr>
    <tr>
      <td class="round8 player">{{tournamentBracket.round8|player:5}}</td>
      <td class="round4 score left-bordered">{{tournamentBracket.round4|score:2}}</td>
      <td class="round2 left-bordered"></td>
      <td class="round1 left-bordered"></td>
    </tr>
    <tr>
      <td class="round8 player">{{tournamentBracket.round8|player:6}}</td>
      <td class="round4"></td>
      <td class="round2 player left-bordered">{{tournamentBracket.round2|player:1}}</td>
      <td class="round1 left-bordered"></td>
    </tr>
    <tr>
      <td class="round8"></td>
      <td class="round4 player left-bordered">{{tournamentBracket.round4|player:3}}</td>
      <td class="round2 score left-bordered">{{tournamentBracket.round2|score:1}}</td>
      <td class="round1"></td>
    </tr>
    <tr>
      <td class="round8 player">{{tournamentBracket.round8|player:7}}</td>
      <td class="round4 score left-bordered">{{tournamentBracket.round4|score:3}}</td>
      <td class="round2"></td>
      <td class="round1"></td>
    </tr>
  </table>
</div>